export default __webpack_public_path__ + "static/9-4fbe1c69c1b5e6ef831eaa41daa97eb2.jpg";